// extracted by mini-css-extract-plugin
export default {"models":"Models_models__Bwn2U","girlCards":"Models_girlCards__tdMvM","girls":"Models_girls__Nlpgw","pagination":"Models_pagination__JBQQ1"};